import { notifyError } from '../../../utils/notify';

export const createEmptyCotacaoForm = () => ({
  compraCotacao_desc: '',
  compraCotacao_nomeInteressado: '',
  compraCotacao_vlr: 0,
  compraCotacao_link: '',
  files: [],
});

export const serializeCotacoesManuaisForPayload = (cotacoes = []) => (
  (Array.isArray(cotacoes) ? cotacoes : []).map((cotacao) => ({
    compraCotacao_id: Number(cotacao?.compraCotacao_id) || null,
    compraCotacao_desc: String(cotacao?.compraCotacao_desc ?? '').trim(),
    compraCotacao_vlr: cotacao?.compraCotacao_vlr ?? 0,
    compraCotacao_link: String(cotacao?.compraCotacao_link ?? '').trim(),
    compraCotacao_nomeInteressado: String(cotacao?.compraCotacao_nomeInteressado ?? '').trim(),
  }))
);

export const cotacaoFormTemDados = (form = {}) => Boolean(
  form.compraCotacao_desc?.trim()
  || form.compraCotacao_nomeInteressado?.trim()
  || form.compraCotacao_link?.trim()
  || Number(form.compraCotacao_vlr) > 0
  || (Array.isArray(form.files) && form.files.length > 0),
);

export const validateCotacaoForm = (form = {}) => {
  if (!(Number(form.compraCotacao_vlr) > 0)) {
    notifyError('Preencha o valor da proposta.');
    return false;
  }
  if (!form.compraCotacao_desc?.trim()) {
    notifyError('Preencha a descrição da proposta.');
    return false;
  }
  return true;
};

export const normalizeCotacaoManualEntry = (form, tempId) => ({
  compraCotacao_id: Number(form?.compraCotacao_id) || undefined,
  compraCotacao_desc: form.compraCotacao_desc?.trim() || '',
  compraCotacao_nomeInteressado: form.compraCotacao_nomeInteressado?.trim() || '',
  compraCotacao_link: form.compraCotacao_link?.trim() || '',
  compraCotacao_vlr: form.compraCotacao_vlr || 0,
  files: Array.isArray(form.files) ? form.files : [],
  _tempId: tempId || form._tempId || `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
});

export const getCotacaoListItemKey = (cotacao) => (
  cotacao?._tempId || cotacao?.compraCotacao_id
);
